import { useTranslation } from 'modules/i18n';
import { useMemo } from 'react';
import { translation } from './translation';

const ONE_DAY_MS = 1000 * 60 * 60 * 24;
const ONE_HOUR_MS = 1000 * 60 * 60;
const ONE_MINUTE_MS = 1000 * 60;

interface ITimeLeft {
  value: string;
  unit: string;
}

export const useWithdrawalTimeLeft = (deadline?: number): ITimeLeft => {
  const { t, keys } = useTranslation(translation);

  return useMemo(() => {
    if (!deadline) {
      return {
        value: '',
        unit: '',
      };
    }

    const timeLeftMs = deadline * 1000;

    if (timeLeftMs < ONE_DAY_MS) {
      const hours = Math.floor(timeLeftMs / ONE_HOUR_MS);
      return {
        value: hours.toString(),
        unit: hours === 1 ? t(keys.hour) : t(keys.hours),
      };
    }
    if (timeLeftMs < ONE_HOUR_MS) {
      const minutes = Math.floor(timeLeftMs / ONE_MINUTE_MS);
      return {
        value: minutes.toString(),
        unit: minutes === 1 ? t(keys.minute) : t(keys.minutes),
      };
    }
    if (timeLeftMs < ONE_MINUTE_MS) {
      return {
        value: t(keys.lessThanOneMinute),
        unit: '',
      };
    }

    const days = Math.round(timeLeftMs / ONE_DAY_MS);
    return {
      value: days.toString(),
      unit: days === 1 ? t(keys.day) : t(keys.days),
    };
  }, [deadline, t]);
};
